export const PARTNER_LABEL="PARTNER_LABEL";
export const PARTNER_DESCRIPTION="PARTNER_DESCRIPTION";
